import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sunrise, Utensils, Apple, Gift, CheckCircle2 } from 'lucide-react';
export function ContentBreakdown() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 px-4 bg-[#FDFBF7]" data-id="element-115">
      <div className="max-w-lg md:max-w-4xl mx-auto" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-118">
            QUÉ INCLUYE NUTRIPEQUES
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto rounded-full" data-id="element-119"></div>
        </div>

        {/* Part 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-120">
          <div className="flex items-center gap-3 mb-6" data-id="element-121">
            <div className="bg-[#E8F5E9] p-3 rounded-xl" data-id="element-122">
              <BookOpen className="w-6 h-6 text-[#2E7D32]" data-id="element-123" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-124">
              PARTE 1: Fundamentos y Herramientas
            </h3>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-125">
            <div className="divide-y divide-gray-100" data-id="element-126">
              {[{
              title: 'La verdad sobre la alimentación infantil',
              desc: "Qué es realmente 'alimentar bien' (y qué no lo es)"
            }, {
              title: 'Principios básicos de nutrición',
              desc: 'Los 4 pilares esenciales sin tecnicismos'
            }, {
              title: 'Cómo armar un plato equilibrado',
              desc: 'Una herramienta visual, simple y repetible'
            }, {
              title: 'Cómo lograr que coman sin peleas',
              desc: 'Psicología del rechazo + estrategias que funcionan'
            }, {
              title: 'Herramientas que facilitan la rutina',
              desc: 'Sistemas reales para días reales'
            }, {
              title: 'El Sistema NutriPeques',
              desc: 'El método de planificación semanal en 30 minutos'
            }].map((item, idx) => <div key={idx} className="p-4 md:p-6 flex flex-col md:flex-row md:items-center gap-2 md:gap-6 hover:bg-gray-50 transition-colors" data-id="element-127">
                  <div className="font-bold text-gray-900 md:w-1/2" data-id="element-128">
                    {item.title}
                  </div>
                  <div className="text-gray-600 md:w-1/2" data-id="element-129">{item.desc}</div>
                </div>)}
            </div>
          </div>
        </motion.div>

        {/* Part 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-130">
          <div className="flex items-center gap-3 mb-8" data-id="element-131">
            <div className="bg-[#FFF3E0] p-3 rounded-xl" data-id="element-132">
              <Utensils className="w-6 h-6 text-[#E65100]" data-id="element-133" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-134">
              PARTE 2: Recetario Completo — 60 Recetas
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-135">
            {/* Mañanas */}
            <div className="bg-[#FFF9C4]/30 rounded-3xl p-6 border border-[#FFF59D]" data-id="element-136">
              <div className="flex items-center gap-3 mb-4" data-id="element-137">
                <Sunrise className="w-8 h-8 text-[#F57F17]" data-id="element-138" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-139">
                  MAÑANAS CON ENERGÍA
                </h4>
              </div>
              <p className="text-sm font-bold text-[#F57F17] mb-3" data-id="element-140">
                16 desayunos nutritivos y fáciles
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-141">
                Desayunos sin azúcar añadida, con proteína, fibra y
                carbohidratos reales. Para que la mañana no sea un caos.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-142">
                <li data-id="element-143">• Pancakes de banana y avena</li>
                <li data-id="element-144">• Muffins de manzana y canela</li>
                <li data-id="element-145">• Waffles de batata y avena</li>
                <li data-id="element-146">• Tortitas de lenteja y zanahoria</li>
                <li data-id="element-147">• Smoothie de durazno y yogur</li>
                <li data-id="element-148">• Avena cremosa, pudding de chía y más</li>
              </ul>
            </div>

            {/* Platos */}
            <div className="bg-[#E8F5E9]/50 rounded-3xl p-6 border border-[#C8E6C9]" data-id="element-149">
              <div className="flex items-center gap-3 mb-4" data-id="element-150">
                <Utensils className="w-8 h-8 text-[#2E7D32]" data-id="element-151" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-152">
                  PLATOS QUE NUTREN
                </h4>
              </div>
              <p className="text-sm font-bold text-[#2E7D32] mb-3" data-id="element-153">
                22 comidas completas y equilibradas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-154">
                Almuerzos y cenas que combinan proteína, vegetales y energía en
                formatos que los niños realmente aceptan.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-155">
                <li data-id="element-156">• Pastel de pollo y verduras cremoso</li>
                <li data-id="element-157">• Ñoquis caseros de calabaza</li>
                <li data-id="element-158">• Mac & Cheese versión saludable</li>
                <li data-id="element-159">• Nuggets de pescado al horno</li>
                <li data-id="element-160">• Pizzetas con base de pollo o coliflor</li>
                <li data-id="element-161">• Lasaña de verduras, wraps integrales y más</li>
              </ul>
            </div>

            {/* Snacks */}
            <div className="bg-[#FFEBEE]/50 rounded-3xl p-6 border border-[#FFCDD2]" data-id="element-162">
              <div className="flex items-center gap-3 mb-4" data-id="element-163">
                <Apple className="w-8 h-8 text-[#C62828]" data-id="element-164" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-165">
                  SNACKS INTELIGENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#C62828] mb-3" data-id="element-166">
                12 meriendas reales y prácticas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-167">
                Para resolver viandas y meriendas sin ultraprocesados ni culpa.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-168">
                <li data-id="element-169">• Barritas de cereal caseras</li>
                <li data-id="element-170">• Trufas energéticas de cacao y avena</li>
                <li data-id="element-171">• Bocaditos de lentejas</li>
                <li data-id="element-172">• Crackers de queso</li>
                <li data-id="element-173">• Bastones asados con dip cremoso y más</li>
              </ul>
            </div>

            {/* Gustitos */}
            <div className="bg-[#F3E5F5]/50 rounded-3xl p-6 border border-[#E1BEE7]" data-id="element-174">
              <div className="flex items-center gap-3 mb-4" data-id="element-175">
                <Gift className="w-8 h-8 text-[#6A1B9A]" data-id="element-176" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-177">
                  GUSTITOS CONSCIENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#6A1B9A] mb-3" data-id="element-178">
                10 recetas especiales sin culpa
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-179">
                Porque prohibir no educa. Ofrecer mejor, sí.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-180">
                <li data-id="element-181">• Brownie de banana y cacao</li>
                <li data-id="element-182">• Gomitas naturales de frutas y verduras</li>
                <li data-id="element-183">• Paletas de banana bañadas en chocolate</li>
                <li data-id="element-184">• "Oreos" saludables sin cocción</li>
                <li data-id="element-185">• Malvadiscos naturales y más</li>
              </ul>
            </div>
          </div>

          {/* Cada receta incluye */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-186">
            <h4 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-187">
              CADA RECETA INCLUYE:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-188">
              {[{
              icon: '⏱️',
              title: 'Tiempo',
              desc: 'Para saber antes de empezar'
            }, {
              icon: '🍽️',
              title: 'Porciones',
              desc: 'Adaptado a porciones infantiles'
            }, {
              icon: '👶',
              title: 'Edad',
              desc: 'Desde 1 año en adelante'
            }, {
              icon: '💚',
              title: 'Beneficio',
              desc: 'Simple, claro, sin tecnicismos'
            }, {
              icon: '💡',
              title: 'Tips',
              desc: 'Versiones freezer, variantes, trucos'
            }].map((item, idx) => <div key={idx} className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl" data-id="element-189">
                  <span className="text-2xl" data-id="element-190">{item.icon}</span>
                  <div data-id="element-191">
                    <div className="font-bold text-gray-900 text-sm" data-id="element-192">
                      {item.title}
                    </div>
                    <div className="text-xs text-gray-600" data-id="element-193">{item.desc}</div>
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <div className="mt-12 flex justify-center" data-id="element-194">
          <button onClick={scrollToOffer} className="w-full max-w-md min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-lg md:text-xl font-bold rounded-2xl shadow-[0_6px_0_#1B5E20] hover:shadow-[0_3px_0_#1B5E20] hover:translate-y-1 transition-all px-6 py-4" data-id="element-195">
            → Quiero acceder al recetario
          </button>
        </div>
      </div>
    </section>;
}